<template>
  <div class="reappro__product product">
    <router-link
      v-if="item.product.id"
      :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.product.photos && item.product.photos[0]"
        :src="imagesurl + '600/' + item.product.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
      <div class="product__stock-container">
        <span class="stock__text">Etat du stock</span>
        <div class="product__stock stock">
          <div
            v-if="
              productCurrentUser.vehicleStocks &&
              productCurrentUser.vehicleStocks[0] &&
              productCurrentUser.vehicleStocks[0].stock <
                productCurrentUser.vehicleStocks[0].minStock
            "
            class="stock__picto red"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="
              productCurrentUser.vehicleStocks &&
              productCurrentUser.vehicleStocks[0] &&
              productCurrentUser.vehicleStocks[0].stock ==
                productCurrentUser.vehicleStocks[0].minStock
            "
            class="stock__picto orange"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="productCurrentUser.vehicleStocks && productCurrentUser.vehicleStocks[0]"
            class="stock__picto green"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <span
            class="stock__number"
            v-if="productCurrentUser.vehicleStocks && productCurrentUser.vehicleStocks[0]"
            >{{ productCurrentUser.vehicleStocks[0].stock }}</span
          >

          <div
            v-if="
              productCurrentUser.productShops &&
              productCurrentUser.productShops[0] &&
              productCurrentUser.productShops[0].stock == 0
            "
            class="stock__picto magasin red"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="
              productCurrentUser.productShops &&
              productCurrentUser.productShops[0] &&
              productCurrentUser.productShops[0].stock <= 10
            "
            class="stock__picto magasin orange"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="productCurrentUser.productShops && productCurrentUser.productShops[0]"
            class="stock__picto magasin green"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <span
            class="stock__number"
            v-if="productCurrentUser.productShops && productCurrentUser.productShops[0]"
            >{{ productCurrentUser.productShops[0].stock }}</span
          >
        </div>
      </div>
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.product.label }}</h3>
        </div>
      </div>
      <p class="product__code">
        <img src="/static/img/pictos/reapprobleufonce.svg" alt="" class="" /> Code article :
        {{ item.product.code }}
      </p>
      <span class="quantity__text">Quantités : </span>
      <div class="product__quantity-container quantity">
        <!-- <div v-if="me.min_max_stock_management && ($store.getters['auth/isRole']('ROLE_TECHNICIAN') == true)" class="quantity__container">
          <input  type="number" class="quantity__value" name="" v-model="item.min_stock" @change="changeMin(item.id, item.min_stock)">
          <span>MIN.</span>
        </div>
        <div v-else class="quantity__container">
          <span class="quantity__value">{{ item.min_stock }}</span>
          <span>MIN.</span>
        </div>
        <div v-if="me.min_max_stock_management && ($store.getters['auth/isRole']('ROLE_TECHNICIAN') == true)" class="quantity__container">
          <input type="number" class="quantity__value" name="" v-model="item.max_stock" @change="changeMax(item.id, item.max_stock)">
          <span>MAX.</span>
        </div>
        <div v-else class="quantity__container">
          <span class="quantity__value">{{ item.max_stock }}</span>
          <span>MAX.</span>
        </div> -->
        <div class="quantity__container">
          <span class="quantity__value">{{ item.min_stock }}</span>
          <span>MIN.</span>
        </div>
        <div class="quantity__container">
          <span class="quantity__value">{{ item.max_stock }}</span>
          <span>MAX.</span>
        </div>
      </div>
    </div>
    <div class="product__btns" v-if="agent != true">
      <router-link
        v-if="item.product.id"
        :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
        class="product__btn product__btn--see"
      >
        <img src="/static/img/pictos/flecheblanche.svg" alt="" />
      </router-link>
      <a v-if="recept == true" href="" class="product__btn product__btn--valid">
        <img src="/static/img/pictos/valider.svg" class="" />
      </a>
      <!-- <a
        v-else-if="me.min_max_stock_management"
        href=""
        class="product__btn product__btn--delete"
        @click.prevent="deleteFromAutoReappro(item.id)"
      >
        <img src="/static/img/pictos/supprimer.svg" class="" />
      </a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductReapproParam",
  props: ["item", "next", "recept", "agent"],
  data() {
    return {
      productCurrentUser: {},
    };
  },
  methods: {
    deleteFromAutoReappro(id) {
      this.$emit("delete", id);
      // this.$http.patch('vehiclestock/'+id, {
      //   restocking: false,
      //   validated: false,
      // }).then(function(){
      //   self.$toastr.success(self.$i18n.t("success.reappro.deleted"));
      //   self.$emit("reload")
      // })
    },
    changeMin(id, min) {
      this.$emit("min", id, min);
    },
    changeMax(id, max) {
      this.$emit("max", id, max);
    },
  },
  computed: {
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
    me: function () {
      let me = this.$store.getters["auth/user"];
      if (typeof me == "string") {
        return JSON.parse(me);
      } else {
        return me;
      }
    },
  },
  created() {
    const self = this;
    //this.$store.dispatch("product/getAllCurrent").then(() => {
    this.productCurrentUser = this.$store.getters["product/getItemCurrent"](self.item.product.id);
    //});
  },
  mounted() {},
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.product {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  background-color: white;
  width: 100%;
  padding-bottom: 20px;
  height: auto;
  border: 1px solid $grisclair;
  margin-bottom: 60px;
  &__image-container {
    width: 50%;
    height: 120px;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    width: 50%;
    height: 100%;
    padding: 20px;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    .product__name-container {
      width: 100%;
      line-height: 1;
    }
  }
  &__name {
    font-size: 15px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
  }
  &__code {
    font-size: 12px;
    color: $grisfonce;
    font-family: "ClanPro";
    img {
      width: 19px;
    }
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: 20px;
    width: 100%;
    position: absolute;
    bottom: -40px;
  }
  .quantity {
    flex: 1;
    display: flex;
    &__text {
      color: $grisfonce;
      font-family: "ClanPro";
      text-transform: uppercase;
      font-size: 12px;
      display: block;
      margin-bottom: 5px;
    }
    &__value {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-color: $grisclair;
      display: inline-block;
      line-height: 55px;
      text-align: center;
      border: none;
      outline: none;
      font-family: "ClanFFBlack";
      font-weight: normal;
      color: $color1;
    }
    &__container {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      width: 50%;
      span {
        display: block;
        font-size: 12px;
        text-transform: uppercase;
        font-family: "ClanFFBlack";
        color: $color1;
        margin-top: 4px;
      }
    }
  }
  &__stock-container {
    border-top: 1px solid $color1;
    padding-top: 15px;
  }
  .stock {
    width: 100%;
    text-transform: uppercase;
    font-family: "ClanPro";
    color: $grisfonce;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    &__picto {
      width: 30px;
      margin-left: 20px;
      position: relative;
      text-align: right;
      img {
        width: 30px;
      }
      &.magasin {
        img {
          width: 25px;
        }
      }
      &:before {
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        opacity: 0.75;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: -10px;
        margin-top: -10px;
        border-radius: 50%;
      }
      &.green {
        &:before {
          background: $vert;
        }
      }
      &.red {
        &:before {
          background: $rouge;
        }
      }
      &.orange {
        &:before {
          background: $orange;
        }
      }
    }
    &__text {
      margin: 0 10px;
      font-family: "ClanPro";
      color: $color1;
      font-size: 12px;
      margin-bottom: 15px;
      display: block;
    }
    &__number {
      text-align: center;
      margin: 0 10px;
      font-family: "ClanFFBlack";
      color: $grisfonce;
      font-size: 16px;
      display: block;
    }
  }
  &__btn {
    width: 80px;
    text-align: center;
    height: 40px;
    color: white;
    line-height: 36px;
    img {
      width: 16px;
    }
    &--see {
      background-color: $color2;
    }
    &--add {
      background-color: $color3;
    }
    &--valid {
      background-color: $vert;
      img {
        width: 25px;
      }
    }
    &--delete {
      background-color: $color1;
      img {
        width: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductReapproParam.vue